import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'software-filters.filters.clear-button.label',
		defaultMessage: 'Clear filters',
		description: 'Button label. Appears on issue filters set and clears all selected filters.',
	},
});
